export class MyArray {
    public static class = ['-green', '-voilet', '-red', '-blue', '-yellow', '-ppp-classic', '-ppp-vip', '-ppp-prime', '-ppp-deluxe', '-ppp-ultimate', '-ppp-doitmyself', '-ppp-epic', '-ppp-blast', '-ppp-base', '-ppp-diy'];
    public static comparePackage = ['Helium Balloons', 'Bonus Tickets for Birthday Star', 'All You Can Play'];
}
